export default {
  "brand": "USFansLink",
  "brandSub": "Centrum zasobów arkusza",
  "nav.home": "Strona główna",
  "nav.guides": "Przewodniki zakupowe",
  "nav.guide": "Przewodnik dla początkujących",
  "nav.review": "Recenzja USFans",
  "nav.shipping": "Koszt wysyłki",
  "nav.qc": "Przewodnik QC",
  "nav.coupon": "Przewodnik kuponów",
  "nav.warehouse": "Przewodnik magazynu",
  "nav.legit": "Czy USFans jest legalny?",
  "buyNow": "Kup teraz",
  "exploreSpreadsheet": "Poznaj arkusz USFans",
  "readGuide": "Przeczytaj przewodnik dla początkujących",
  "language": "Język",
  "backHome": "Powrót na stronę główną",
  "mainSite": "Odwiedź główną witrynę",
  "footer.disclaimer": "USFansLink.fun to niezależne źródło informacji. Nie jest oficjalną witryną USFans i nie gwarantuje sprzedawców, produktów, cen, usług wysyłki ani wyników transakcji. Zawsze sprawdzaj aktualne informacje przed zakupem.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.independent": "Niezależne źródło",
  "footer.updated": "Aktualizowane przewodniki",
  "footer.multilingual": "Wsparcie wielojęzyczne",
};